<script setup lang="ts" name="FormWizardFooter">
import { computed } from 'vue';

import BaseButton from '~/components/BaseButton.vue';
import Icon from '~/components/Icon.vue';
import StepperFooterLayout from '~/components/StepperFooterLayout.vue';

import type { IStepperStep } from '~/types';

const { totalSteps, activeStepIdx, steps } = defineProps<{
  steps?: IStepperStep[];
  totalSteps: number;
  activeStepIdx: number;
  onPreviousStep: () => void;
}>();

const currentStep = computed(() => steps?.[activeStepIdx]);

const actionButtons = computed(() => {
  return (
    currentStep.value?.actionButtons?.filter(({ type }) => type === 'action') ||
    []
  );
});

const hasPreviousStep = computed(() => activeStepIdx > 0);

const hasNextStep = computed(() => activeStepIdx < totalSteps - 1);

const submitButton = computed(() => {
  const submitTypeButton = currentStep.value?.actionButtons?.find(
    (button) => button.type === 'submit',
  );

  return {
    ...submitTypeButton,
    label: submitTypeButton?.label || (hasNextStep.value ? 'Next' : 'Submit'),
  };
});
</script>

<template>
  <StepperFooterLayout>
    <BaseButton
      v-for="button in actionButtons"
      :key="button.label"
      :variant="button.variant"
      :to="button.to"
      :href="button.href"
      :target="button.target"
      @click="button.handler"
    >
      {{ button.label }}
    </BaseButton>

    <BaseButton
      v-if="hasPreviousStep"
      variant="btn-secondary"
      @click="onPreviousStep"
    >
      back
    </BaseButton>
    <BaseButton type="submit" :disabled="submitButton?.disabled">
      <p>{{ submitButton?.label }}</p>
      <template v-if="hasNextStep" #rightIcon>
        <Icon icon="mdi:chevron-right" />
      </template>
    </BaseButton>
  </StepperFooterLayout>
</template>
